import { CheckType } from "./checkType";

const filterData = (data, filters) => {
    // const app_name = filters['app_name']
    // const action_id = filters['action_id']
    // const bulk_action = filters['bulk_action']
    for (const f of Object.keys(filters)) {
        if(filters[f] === undefined){
            return []
        }
        if(CheckType(filters[f]) === 'Array'){
            data = data.filter( (action) => filters[f].includes(action[f]) )
        }
        else if((CheckType(filters[f]) === 'String' || CheckType(filters[f]) === 'Boolean' )&& f.endsWith('__neq')){
            data = data.filter( (action) => filters[f] !== action[f.replace('__neq', '')] )
        }
        else if(CheckType(filters[f]) === 'String' || CheckType(filters[f]) === 'Boolean'){
            data = data.filter( (action) => filters[f] === action[f] )
        }
    }
    return data

    // if(filters.hasOwnProperty('action_id')){
    //     const action_id = filters['action_id']
    //     const type_action = CheckType(action_id)
    //     var actions = [];
    //     if(type_action === "Array"){
    //         actions = data.filter( (form) => action_id.includes(form.action_id))
    //     }
    //     else if (type_action === 'String'){
    //         actions = data.filter( (form) => form.action_id === action_id)
    //     }
    //     return actions
    // } 
    // else if(filters.hasOwnProperty('app_name') && filters.hasOwnProperty('detail') ){
    //     const app_name = filters['app_name']
    //     const detail = filters['detail']
    //     return data.filter( (form) => form.app_name === app_name && form.detail == detail)
    // }
}	

export default filterData
